import { useCore } from "@spectral-finance/react-core";
import React, { useEffect } from "react";
import {
  DialogSteps,
  useDialogStepsContext,
} from "../../contexts/DialogStepsContext";
import { useSpectral } from "../../contexts/SpectralContext";
import { Dialog } from "../Dialog";
import { Bundle } from "./steps/Bundle";
import { Faq } from "./steps/Faq";
import { Onboarding } from "./steps/Onboarding";
import { Success } from "./steps/Success";
import { WalletConnection } from "./steps/WalletConnection";

interface SpectralDialogProps {
  open: boolean
  partnerLogo: string;
  onScoreComputed: (s: number) => void;
}

export const SpectralDialog = ({
  open,
  partnerLogo,
  onScoreComputed,
}: SpectralDialogProps) => {
  const { close } = useSpectral();
  const { currentStep } = useDialogStepsContext();
  const { score, account } = useCore();

  useEffect(() => {
    if (!score.toString()) return;
    onScoreComputed(score.score);
  }, [score]);

  return (
    <Dialog open={open} onClose={close}>
      {(() => {
        switch (currentStep) {
          case DialogSteps.ONBOARDING: return <Onboarding partnerLogo={partnerLogo} />;
          case DialogSteps.FAQ: return <Faq />;
          case DialogSteps.WALLET_CONNECTION: {
            if (account.minted) {
              return <Bundle/>
            }
            return <WalletConnection />;
          }
          case DialogSteps.BUNDLE: return <Bundle />;
          case DialogSteps.SUCCESS: return <Success />;
        }
      })()}
    </Dialog>
  );
};
